import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateContentFolderDocument } from './update.generated';

export const useUpdateContentFolder = (
  options: ApiOptions<typeof UpdateContentFolderDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(UpdateContentFolderDocument, {
    ...useNotifications(UpdateContentFolderDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.content_folders.update_success'),
    }),
    ...options,
  });
};
